import { FC } from "react";

import tourismLegalStyles from "web/Pages/Checkout/TourismDomestic/SharedComponents/LegalInformation/legalInformation.scss";

import type { AccordionVariant } from "web/Components/Common/Accordion/accordion";

import { Classes } from "web/types/Common";

import { useAppContext } from "web/context/app";
import { useGetEmployeeConfigurationQuery } from "web/features/employee/employeeApiSlice";

import OrderDetailsLegalAccordions from "./orderDetailsLegalAccordions";

export interface IOrderDetailsAnixeTourismLegalsProps {
  itemClassName?: string;
  accordionClassName?: string;
  contentClassName?: string;
  accordionClasses?: Classes;
  groupClassName?: string;
  variant?: AccordionVariant;
}

const OrderDetailsAnixeTourismLegals: FC<
  IOrderDetailsAnixeTourismLegalsProps
> = ({
  itemClassName,
  accordionClassName = tourismLegalStyles.accordionRoot,
  contentClassName,
  accordionClasses,
  groupClassName,
  variant,
}) => {
  const { isMobile } = useAppContext();
  const { data: employeeConfig } = useGetEmployeeConfigurationQuery();

  return (
    <OrderDetailsLegalAccordions
      withdrawalContent={employeeConfig?.tourismWithdrawal}
      itemClassName={itemClassName}
      accordionClassName={accordionClassName}
      contentClassName={contentClassName}
      contentWrapper="p"
      accordionClasses={accordionClasses}
      groupClassName={groupClassName}
      templateClassName={tourismLegalStyles.text}
      variant={variant ?? (isMobile ? "tertiary" : "primary")}
    />
  );
};

export default OrderDetailsAnixeTourismLegals;
